import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import NavPanel from '../../../Components/NavPanel/NavPanel';
import classes from './ArticlePage.module.scss';
import { GeneralContext } from '../../../context/generalContext';
import vkIconGrey from '../../../images/icon-vk-grey.svg';
import vkIconBlue from '../../../images/icon-vk-blue.svg';
import noPhoto from '../../../images/noPhoto.png';
import NotFound from '../../NotFound/NotFound';
import { articleAPI } from '../../../services/GeneralService';
import SkeletonArticle from '../../../Components/Skeleton/SkeletonArticle/SkeletonArticle';

export default function ArticlePage() {
  const { activeLanguage } = useContext(GeneralContext);
  const location = useLocation();
  const params = useParams();
  const [item, setItem] = useState(null);
  const [recommended, setRecommended] = useState(null);

  const { data: articleData, isLoading, isError } = articleAPI.useFetchOneArticleQuery(params.articleName);

  useEffect(() => {
    if (articleData) {
      setItem(articleData);
    }
  }, [articleData]);

  useEffect(() => {
    if (item && item.recommended) {
      setRecommended(
        item.recommended.map(rec => {
          const tempDiv = document.createElement('div');
          const reg = /(?=<style>)(.*)(?:style>)/gi;
          tempDiv.innerHTML = rec.content.text.replace('<strong>', '').replace(reg, '');

          const tempDivEn = document.createElement('div');
          tempDivEn.innerHTML =
            rec.content.text_en.replace('<strong>', '').replace(reg, '') ||
            rec.content.text.replace('<strong>', '').replace(reg, '');
          if (tempDiv.hasChildNodes())
            return {
              id: rec.id,
              title: rec.title,
              title_en: rec.title_en,
              image: rec.image,
              name: rec.name,
              date: rec.date,
              text: tempDiv.children[0]?.textContent,
              text_en: tempDivEn.children[0]?.textContent,
            };
        }),
      );
    }
  }, [item]);

  // скролл на начало страницы

  useEffect(() => {
    if (location && item) {
      window.scrollTo(0, 0);
    }
  }, [location, item]);
  console.log(item);
  return (
    <>
      {isLoading && <SkeletonArticle />}
      {(item?.title || item?.content) && (
        <div className='wrapper'>
          {item?.title ? (
            <Helmet>
              <title>
                {activeLanguage === 1
                  ? `${item?.title} | Brasserie Lambic`
                  : `${item?.title_en} | Brasserie Lambic` || `${item?.title} | Brasserie Lambic`}
              </title>
            </Helmet>
          ) : (
            <Helmet>
              <title>{activeLanguage === 1 ? 'Статьи | Brasserie Lambic' : 'Articles | Brasserie Lambic'}</title>
            </Helmet>
          )}
          {item && (
            <>
              <NavPanel
                name={activeLanguage === 1 ? 'Статьи' : 'Articles'}
                link={activeLanguage === 1 ? '/articles' : '/en/articles'}
                name2={activeLanguage === 1 ? item.title : item.title_en || item.title}
                link2={activeLanguage === 1 ? `/articles/${item.name}` : `/en/articles/${item.name}`}
              />
              <h1 className={classes.title}>{activeLanguage === 1 ? item.title : item.title_en || item.title}</h1>
              <div className={classes.page}>
                <div className={classes.article}>
                  <LazyLoadImage
                    className={classes.articleImg}
                    src={item.img ? item.img : noPhoto}
                    alt='article illustration'
                  />
                  {item.content &&
                    item.content.map((contentPart, index) =>
                      contentPart.type === 'заголовок' ? (
                        <div
                          className={classes.articleSubTitle}
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: activeLanguage === 1 ? contentPart.text : contentPart.text_en || contentPart.text,
                          }}
                        />
                      ) : (
                        <p
                          className={classes.articleText}
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: activeLanguage === 1 ? contentPart.text : contentPart.text_en || contentPart.text,
                          }}
                        />
                      ),
                    )}
                  <div className={classes.articleInfo}>
                    <div className={classes.articleInfoItem}>
                      {activeLanguage === 1 ? 'Опубликовано: ' : 'Published on '}
                      {activeLanguage === 1
                        ? new Date(item.date).toLocaleString('ru', {
                            month: 'long',
                            day: 'numeric',
                          })
                        : new Date(item.date).toLocaleString('en', {
                            month: 'long',
                            day: 'numeric',
                          })}
                    </div>
                    <a
                      className={`${classes.articleInfoItem} ${classes.articleInfoItemVk}`}
                      href={`https://vk.com/share.php?url=${window.location.href}`}
                      rel='noreferrer'
                      target='_blank'
                    >
                      {/* <div className={`${classes.articleInfoItem} ${classes.articleInfoItemVk}`}> */}
                      <div className={classes.articleVkText}>
                        {activeLanguage === 1 ? 'Рассказать друзьям' : 'Tell friends'}
                      </div>
                      <img className={classes.articleVkImgGrey} src={vkIconGrey} alt='vk icon' />
                      <img className={classes.articleVkImgBlue} src={vkIconBlue} alt='vk icon' />
                    </a>
                  </div>
                </div>
                <div className={classes.also}>
                  <div className={classes.alsotitle}>{activeLanguage === 1 ? 'Читайте также' : 'Also read'}</div>
                  {recommended &&
                    recommended.map(rec => (
                      <React.Fragment key={rec.id}>
                        <Link to={activeLanguage === 1 ? `/articles/${rec.name}` : `/en/articles/${rec.name}`}>
                          <div className={classes.card}>
                            <LazyLoadImage
                              className={classes.cardImg}
                              src={rec.image ? rec.image : noPhoto}
                              alt='article illustration'
                            />
                            <div className={classes.cardDescription}>
                              <div className={classes.cardTitle}>
                                {activeLanguage === 1 ? rec.title : rec.title_en || rec.title}
                              </div>
                              <p
                                className={classes.cardText}
                                dangerouslySetInnerHTML={{
                                  __html: activeLanguage === 1 ? rec.text : rec.text_en || rec.text,
                                }}
                              />
                              <p className={classes.cardDate}>
                                {activeLanguage === 1
                                  ? new Date(rec.date)
                                      .toLocaleString('ru', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                      })
                                      .slice(0, -3)
                                  : new Date(rec.date).toLocaleString('en', {
                                      year: 'numeric',
                                      month: 'long',
                                      day: 'numeric',
                                    })}
                              </p>
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {!(item?.title || item?.content || isLoading) && <NotFound />}
      {isError && <NotFound />}
    </>
  );
}
